/* eslint-disable max-len */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const Tag = require('@andes/tag');
const Dropdown = require('@andes/dropdown');
const Message = require('@andes/message');
const CopyToClipboard = require('react-copy-to-clipboard');
const { useLiveDemoContext } = require('./Provider/liveDemoContext');
const Download = require('./Images/download');
const Copy = require('./Images/copy');
const { addLineInCode, downloadString } = require('./utils');
const { getEventTracker } = require('../../../event-tracker');

const { DropdownItem } = Dropdown;

const { useState, useEffect } = React;

const SnippetBack = ({ componentSnippetBack, i18n, liveDemoId, lang }) => {
  const Tracker = getEventTracker();

  const { formData, setBehaviorData } = useLiveDemoContext();
  const contentAvailable = componentSnippetBack(formData);
  if (!contentAvailable || contentAvailable?.length < 1) {
    return <></>;
  }

  const filesAvailable = contentAvailable?.map((item) => item?.name);
  const [selectedContent, setSelectedContent] = useState(contentAvailable[0]);
  const [selectedFile, setSelectedFile] = useState(contentAvailable[0]?.value);
  const [selectedLanguage, setSelectedLanguage] = useState(
    contentAvailable[0]?.value,
  );

  useEffect(() => {
    if (liveDemoId === 'payment-brick') {
      const { paymentMethod } = formData;

      let updatedPaymentMethod = paymentMethod.filter(item => item !== 'card');

      if ((updatedPaymentMethod.includes('creditCard') || updatedPaymentMethod.includes('debitCard')) && !updatedPaymentMethod.includes('card')) {
        updatedPaymentMethod.push('card');
      } else if (!updatedPaymentMethod.includes('creditCard') && !updatedPaymentMethod.includes('debitCard') && updatedPaymentMethod.includes('card')) {
        updatedPaymentMethod = updatedPaymentMethod.filter(item => item !== 'card');
      }

      const selectedItem = componentSnippetBack(formData).filter(item => item.value === selectedFile && updatedPaymentMethod.includes(item.payment));

      const selectedCodes = selectedItem.map(item => item.code);
      const concatenatedCodes = selectedCodes.join('');

      if (selectedCodes.length > 0) {
        setSelectedContent({
          code: concatenatedCodes,
          name: selectedItem[0]?.value,
          codes: selectedItem,
          extension: selectedItem[0].extension,
          type: selectedItem[0]?.type,
        });
      } else {
        setSelectedContent(contentAvailable[0])
      }
    } else if (liveDemoId === 'checkout-pro-brick') {
      const selectedItem = componentSnippetBack(formData, i18n).find(
        (item) => item?.name === selectedFile,
      );
      const formatCode = selectedItem?.code ? addLineInCode(selectedItem.code) : '';
      setSelectedContent({
        code: formatCode,
        name: selectedItem?.name,
        type: selectedItem?.type,
      });
    } else {
      const selectedItem = componentSnippetBack(formData).find(
        (item) => item?.value === selectedFile,
      );
      setSelectedContent({
        code: selectedItem.code,
        name: selectedItem.value,
        extension: selectedItem.extension,
        type: selectedItem.type,
      });
    }
  }, [formData, selectedFile, componentSnippetBack]);

  useEffect(() => {
    if (window && window.Prism) {
      window.Prism.highlightAll();
    }
  }, [selectedContent]);

  function onChangeLanguage(value) {
    if (value) {
      setSelectedFile(value);
      setSelectedLanguage(value);
    }
  }

  function getNameFromPayment(value) {
    switch (value) {
      case 'card':
        return i18n.gettext('Crédito/Débito');
      case 'ticket':
        return i18n.gettext('Ticket');
      case 'bankTransfer':
        return i18n.gettext('Transferência Bancária');
      default:
        return '';
    }
  }

  return (
    <div className="live-demo-snippet-container">
      <div className="live-demo-snippet-list">
        <Dropdown
          type="form"
          label={i18n.gettext('Lenguaje')}
          defaultValue="node"
          onChange={(event, value) => {
            Tracker.send(`mpdevelopers/live_demo/select_back_language_${liveDemoId}`, value);
            onChangeLanguage(value);
          }}
        >
          {[...new Set(contentAvailable.map((item) => item.value))].map((value) => (
            <DropdownItem key={value} value={value} title={value} />
          ))}
        </Dropdown>

        {filesAvailable.filter((item) => item === selectedLanguage).length > 1 ? (
          <>
            <span className="live-demo-snippet-label">Arquivos</span>
            {filesAvailable
              .filter((item) => item === selectedLanguage)
              ?.map((fileName) => (
                <Tag
                  label={fileName}
                  clickable
                  className={`live-demo-snippet-tag live-demo-snippet-tag${selectedFile === fileName ? '--selected' : ''}`}
                  onClick={() => {
                    setSelectedFile(fileName);
                  }}
                />
              ))}
          </>
        ) : <div className="live-demo-snippet-padding" />}

      </div>

      {liveDemoId === 'payment-brick' ? (
        <>
          {formData.paymentMethod?.find(item => item === 'mercadoPago') && (
            <div>
              <span className="live-demo-snippet-title-payment">{i18n.gettext('Mercado Pago')}</span>
              <Message
                type="neutral"
                hierarchy="quiet"
              >
                {i18n.jsx.gettext('Los pagos con Cuenta de {0}Mercado Pago y Cuotas sin tarjeta{1} no necesitan ser enviados a través del backend. Si el usuario selecciona esta opción como medio de pago, el {2}preferenceId{3} enviado en la inicialización del Brick es el encargado de redirigir al comprador al sitio web de Mercado Pago, donde el pago se realizará directamente en nuestro sitio. Para redirigir al comprador a tu sitio, puede configurar {2}back_urls{3} como se describe {5}en este artículo.{6}', {
                  tags: {
                    0: '<b>',
                    1: '</b>',
                    2: '<b><i>',
                    3: '</i></b>',
                    4: '<br><br>',
                    5: `<a href="/developers/${lang}/docs/checkout-bricks/payment-brick/additional-customization/preferences#bookmark_redirigir_al_comprador_a_tu_sitio_web" rel="noopener noreferrer" target="_blank">`,
                    6: '</a>',
                  },
                })}
              </Message>
            </div>
          )}

          {selectedContent?.codes?.map((item) => (
            <div>
              <span className="live-demo-snippet-title-payment">{getNameFromPayment(item?.payment)}</span>
              <pre className={`language-${item?.type} line-numbers`}>
                <code className={`language-${item?.type} line-numbers`}>
                  {item?.code}
                </code>
              </pre>
            </div>

          ))}
        </>
      ) : (
        <pre className={`language-${selectedContent?.type} line-numbers`}>
          <code className={`language-${selectedContent?.type} line-numbers`}>
            {selectedContent?.code}
          </code>
        </pre>
      )}

      <div className="live-demo-snippet-footer">
        <div className="live-demo-snippet-spacing download">
          <CopyToClipboard
            text={selectedContent?.code}
            onCopy={() => {
              Tracker.send(`mpdevelopers/live_demo/click_back_download_${liveDemoId}`, 'download');
            }}
          >
            <div
              role="button"
              tabIndex="0"
              className="live-demo-snippet-action"
              onClick={() => downloadString(selectedContent.code, `snippet.${selectedContent.extension}`)}
              onKeyPress={(e) => e.key === 'Enter' && downloadString(selectedContent.code, `snippet.${selectedContent.extension}`)}
            >
              <Download alt={i18n.gettext('Descargar código')} />
              <span>{i18n.gettext('Descargar')} </span>
            </div>
          </CopyToClipboard>
        </div>
        <div className="live-demo-snippet-spacing copy">
          <CopyToClipboard
            text={selectedContent?.code}
            onCopy={() => {
              Tracker.send(`mpdevelopers/live_demo/click_back_copy_${liveDemoId}`, 'copy');

              setBehaviorData(prev => ({
                ...prev,
                snackbarData: {
                  show: true,
                  message: i18n.gettext('Código copiado con éxito.'),
                  type: 'success',
                  delay: 3000,
                },
              }));
            }}
          >
            <div className="live-demo-snippet-action">
              <Copy alt={i18n.gettext('Copiar código')} />
              <span>{i18n.gettext('Copiar')}</span>
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

module.exports = SnippetBack;
